// import PropTypes from 'prop-types';

const Loading = () => {
    return <div className="loader"></div>;
};
export default Loading;
